// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1JhYW","productName":"Table_productName__2NcP8"};